import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoop, selectCoopActiveProjectEndTime } from "../../../selectors/selectCoopInfo";
import { selectCoopProjectInfo } from "../../../selectors/selectCoopProjectInfo";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilCoopProject } from "../../../utils/utilCoopProject";
import { utilTime } from "../../../utils/utilTime";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { ButtonSmallDelete } from "../../generic/common/ButtonSmallDelete";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
import { TimerWithIcon } from "../../generic/timer-with-icon/TimerWithIcon";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionCoopProjectInfoRequest } from "../actionCoop";
var _CoopProjectProgress = function (_a) {
    var activeCoopProject = _a.activeCoopProject, coopProject = _a.coopProject, coopId = _a.coopId, playerId = _a.playerId, onOverViewClick = _a.onOverViewClick, onStopClick = _a.onStopClick, projectEndTime = _a.projectEndTime;
    if (!activeCoopProject || !activeCoopProject.projectId) {
        return React.createElement(React.Fragment, null);
    }
    var projectDifficultyLevelType = utilCoopProject.getProjectDifficultyLevelType(coopProject, activeCoopProject.difficulty);
    var progress = utilTime.timerProgressReversed(activeCoopProject.remainingTime, projectDifficultyLevelType.duration);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flex flex--guts" },
            React.createElement(TimerWithIcon, { icon: IdIcon.TimeIcn, iconStyle: IdStyles.IconMedium, progressPercent: progress, remainingTime: projectEndTime })),
        React.createElement("div", { className: "button-ribbon" },
            React.createElement(ButtonSmallDelete, { onClick: onStopClick },
                React.createElement(Icon, { icon: IdIcon.TrashIcn, styleId: IdStyles.IconMedium })),
            React.createElement(ButtonPrimary, { onClick: function () { return onOverViewClick(playerId, coopId, activeCoopProject.projectId); } },
                React.createElement(TextLoca, { id: IdLoca.overview, className: IdStyles.TextButtonDefault })))));
};
var mapState = function (state) {
    return {
        activeCoopProject: selectCoopProjectInfo(state),
        coopId: selectCoop(state).id,
        playerId: selectPlayerInfo(state).playerId,
        projectEndTime: selectCoopActiveProjectEndTime(state),
    };
};
var mapDispatch = function (dispatch) {
    return {
        onOverViewClick: function (playerId, coopId, projectId) {
            return dispatch(actionCoopProjectInfoRequest({ playerId: playerId, projectId: projectId, coopId: coopId }));
        },
        onStopClick: function () { return dispatch(actionModalOpen(IdModal.CoopProjectStopConfirm)); },
    };
};
export var CoopProjectProgress = connect(mapState, mapDispatch)(_CoopProjectProgress);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/CoopProjectProgress.tsx
// module id = 2595
// module chunks = 3